import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetEditionsDashboard_editionsDashboard as EditionsDashboard,
    GetEditionsDashboard as GetEditionsDashboardQuery,
    GetEditionsDashboardVariables as GetEditionsDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_EDITIONS_DASHBOARD from '../queries/get-editions-dashboard.graphql';

export const useGetEditionsDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    editionsDashboard: EditionsDashboard;
} => {
    const {loading, data, error} = useQuery<
        GetEditionsDashboardQuery,
        GetEditionsDashboardQueryVariables
    >(GET_EDITIONS_DASHBOARD, {
        variables: {input},
        notifyOnNetworkStatusChange: true,
    });

    const {editionsDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        editionsDashboard,
    };
};
